export function warnInDev(message: string) {
  // Don't do anything if we're in production.
  if (process.env.NODE_ENV === 'production') {
    return
  }

  // eslint-disable-next-line no-console
  console.warn(message)
}

export function errorInDev(message: string) {
  // Don't do anything if we're in production.
  if (process.env.NODE_ENV === 'production') {
    return
  }

  throw new Error(message)
}
